import React, { useEffect } from "react";
import "react-range-slider-input/dist/style.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchProducts } from "./features/productSlice";
import ProductSort from "./ProductSort";
import FilterSection from "./FilterSection";
import ProductData from "./ProductData";
import { fetchWishlist } from "./features/wishlistSlice";
import { Helmet } from 'react-helmet-async';

const Shop = () => {
  const dispatch = useDispatch();
  const {
    products,
    isloading,
    sortType,
    isError,
    filteredProducts,
    noProductsFound,
  } = useSelector((state) => state.product);
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  // console.log("products in shop", products);
  // const user = useSelector((state) => state.auth);
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchProducts());
    if (user && token) {
      dispatch(fetchWishlist());
    }
  }, [dispatch, user, token]);
  useEffect(() => {
    if (isError) {
      toast.error(isError);
    }
  }, [isError]);

  // Add effect to show toast when no products are found
  useEffect(() => {
    if (noProductsFound) {
      toast.info(
        "No products found for the selected filters. Showing all products."
      );
    }
  }, [noProductsFound]);

  // Enhanced sort function to handle all cases
  const getSortedProducts = () => {
    if (!products) return [];

    const productsToSort =
      filteredProducts.length > 0 ? [...filteredProducts] : [...products];

    switch (sortType) {
      case "newly_added":
        return productsToSort.sort(
          (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
        );

      case "lowest_price":
        return productsToSort.sort((a, b) => {
          const priceA =
            a.weights[0].prices.India * (1 - a.discount_percentage / 100);
          const priceB =
            b.weights[0].prices.India * (1 - b.discount_percentage / 100);
          return priceA - priceB;
        });

      case "highest_price":
        return productsToSort.sort((a, b) => {
          const priceA =
            a.weights[0].prices.India * (1 - a.discount_percentage / 100);
          const priceB =
            b.weights[0].prices.India * (1 - b.discount_percentage / 100);
          return priceB - priceA;
        });

      case "name_asc":
        return productsToSort.sort((a, b) =>
          a.productName.localeCompare(b.productName)
        );

      case "name_desc":
        return productsToSort.sort((a, b) =>
          b.productName.localeCompare(a.productName)
        );

      case "rating_desc":
        return productsToSort.sort(
          (a, b) => (b.averageRating || 0) - (a.averageRating || 0)
        );

      case "rating_asc":
        return productsToSort.sort(
          (a, b) => (a.averageRating || 0) - (b.averageRating || 0)
        );

      case "discount_desc":
        return productsToSort.sort(
          (a, b) => (b.discount_percentage || 0) - (a.discount_percentage || 0)
        );

      default:
        return productsToSort;
    }
  };

  const sortedProducts = getSortedProducts();

  // Use sortedProducts for display
  if (isloading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Shop Indian Sweets & Snacks Online - Sweetz</title>
        <meta name="description" content="Browse and buy from our wide selection of authentic Indian sweets and snacks. Fresh, traditional, and modern delicacies available for delivery." />
        <meta name="keywords" content="buy Indian sweets online, Indian snacks shop, traditional sweets store, sweet shop online, Indian delicacies" />
        <meta property="og:title" content="Shop Indian Sweets & Snacks Online - Sweetz" />
        <meta property="og:description" content="Browse and buy from our wide selection of authentic Indian sweets and snacks. Fresh, traditional, and modern delicacies available for delivery." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={`https://res.cloudinary.com/damoxae5y/image/upload/v1741935873/snslogo_v202wa.png`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Sweetz" />
        {/* Shop Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": products?.slice(0, 10).map((product, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                "@type": "Product",
                "name": product.productName,
                "image": product.productImages?.[0] || "",
                "url": `${window.location.origin}/productdetails/${product.slug}`
              }
            }))
          })}
        </script>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <section className="banner-innr">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="banner-innr-content">
                <h3 style={{ color: "#3c3260" }}>Shop</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tp-space shop-sec">
        <div className="container">
          <div className="row">
            <FilterSection />
            <div className="col-lg-9 col-md-8">
              <div className="product-head justify-content-between">
                <p className="mb-0 text-dark fw-500">
                  {sortedProducts.length}-Products Found
                </p>
                <ProductSort sortType={sortType} />
              </div>
              <div className="product-sec">
                <div className="row">
                  {sortedProducts && sortedProducts.length > 0 ? (
                    sortedProducts.map((product) => (
                      <ProductData
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))
                  ) : (
                    <div className="not-availabe">
                      <h6>No products available.</h6>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Shop;
